import { BasicModel } from "../basic/basic.model";
import { BasicWithLibelleModel } from "../basic/basicWithLibelle.model";
import { SocieteLinkedModel } from "../societe-linked/societe-linked.model";
import { SsFamilleModel } from "./ss-famille.model";

export class CategorieModel extends BasicModel implements BasicWithLibelleModel {
  idSsFamille: number;
  ssFamille: SsFamilleModel;
  code: string;
  libelle: string;
  seuil: number = 0;
  codeTva: string;
  creaEnveloppe: boolean;
}